export default __webpack_public_path__ + "static/media/Highlord's Greatbow.ae171f66.jpg";